<script lang="ts">
  import { Label } from '$lib/components/ui/label';

  import { Checkbox } from '$lib/components/ui/checkbox';

  import { cn } from '$lib/utils';
  import { v4 as uuidv4 } from 'uuid';
  import { EditorJs } from 'query-strapi-v4';
  import { findReplaceLinksInText } from './handle-links';
  type Block = $$Generic<EditorJs.CheckList | undefined>;
  export let block = undefined as Block;

  const slugifyFromText = (text: string) => {
    return text?.replace(/ /g, '-').toLowerCase();
  };

  const uuid = uuidv4();

  const createFriendlyLabel = (text: string, index: number) =>
    slugifyFromText(text.trim().substring(0, 5)) + '-' + index + uuid;

  const cleanText = (text: string) => {
    const replacedTextWithLinks = findReplaceLinksInText(text);
    const codeRegex = /<code class="inline-code">(.*?)<\/code>/g;
    const replacedCode = replacedTextWithLinks.replace(
      codeRegex,
      '<code class="relative rounded bg-muted px-[0.3rem] py-[0.2rem] font-mono text-sm font-semibold">$1</code>'
    );
    // also replace <mark class="bg-muted-foreground/50 font-semibold"> with <mark class="bg-muted font-semibold text-foreground">
    const markRegex = /<mark class="cdx-marker">(.*?)<\/mark>/g;
    const replacedMark = replacedCode.replace(
      markRegex,
      '<mark class="bg-muted font-semibold text-foreground">$1</mark>'
    );
    return replacedMark;
  };
</script>

{#if block?.data?.items?.length}
  <fieldset class="space-y-5 my-6 ml-6 [&>li]:mt-2">
    {#each block.data.items as item, index (uuidv4())}
      <div class="flex items-center space-x-2">
        <Checkbox
          id={createFriendlyLabel(item.text, index)}
          bind:checked={item.checked}
          aria-labelledby={createFriendlyLabel(item.text, index) + '-label'}
        />
        <div class="grid gap-1.5 leading-none">
          <Label
            id={createFriendlyLabel(item.text, index) + '-label'}
            for={createFriendlyLabel(item.text, index)}
            class="text-sm font-medium leading-normal peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            {@html cleanText(item.text)}
          </Label>
        </div>
      </div>
    {/each}
  </fieldset>
{/if}
